export default "__VITE_ASSET__H7pPh7Bh__"